import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ActionMenuStateService {
  private activeMenuIdSubject = new BehaviorSubject<string | null>(null);
  public activeMenuId$ = this.activeMenuIdSubject.asObservable();

  /**
   * Set the currently active menu ID
   * @param menuId - The unique identifier for the menu
   */
  setActiveMenu(menuId: string): void {
    this.activeMenuIdSubject.next(menuId);
  }

  /**
   * Clear the active menu (close all menus)
   */
  clearActiveMenu(): void {
    this.activeMenuIdSubject.next(null);
  }

  /**
   * Check if a specific menu is currently active
   * @param menuId - The menu ID to check
   * @returns boolean indicating if the menu is active
   */
  isMenuActive(menuId: string): boolean {
    return this.activeMenuIdSubject.value === menuId;
  }

  /**
   * Get the currently active menu ID
   * @returns string | null - The active menu ID or null if no menu is active
   */
  getActiveMenuId(): string | null {
    return this.activeMenuIdSubject.value;
  }
}
